import { Link } from 'react-router-dom';
import type { Parent } from '@xiaopeiban/shared';

const LINKS = [
  { to: '/children', icon: '👶', label: '孩子管理', hint: '设置生日、头像、手动调马币' },
  { to: '/chat-archive', icon: '💬', label: '聊天记录', hint: '查看孩子和 AI 宠物的所有对话' },
  { to: '/settings', icon: '⚙️', label: '账号设置', hint: '修改密码、登出' },
];

export default function MorePage({ parent }: { parent: Parent; onLogout: () => void }) {
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-title">⚙️ 更多</div>
        <div className="page-subtitle">{parent.email}</div>
      </div>

      {LINKS.map(l => (
        <Link
          key={l.to}
          to={l.to}
          style={{
            display: 'block', padding: 16, marginBottom: 10,
            background: 'white', borderRadius: 16, boxShadow: 'var(--shadow)',
            textDecoration: 'none', color: 'inherit',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ fontSize: 32 }}>{l.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 800 }}>{l.label}</div>
              <div className="muted" style={{ fontSize: 13 }}>{l.hint}</div>
            </div>
            <div style={{ fontSize: 20, color: 'var(--text-muted)' }}>›</div>
          </div>
        </Link>
      ))}
    </div>
  );
}
